import { HexElementProperties } from '~/types/drill'
import { TOPIC_HEXAGON_PROPERTIES } from '~/shared/constants/drill.const'

export function getProperties(index: number): HexElementProperties {
  switch (index) {
    case 1:
    case 5:
    case 7:
    case 9:
    case 11:
    case 15:
    case 17:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
      }

    case 3:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: '#1400ff',
        gemstoneOutlineColor: 'white',
        i18nKey: 'playAlt',
        splat: 'left',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-white',
        },
      }

    case 13:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: '#1400ff',
        gemstoneOutlineColor: 'white',
        i18nKey: 'playAlt',
        splat: 'right',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-white',
        },
      }

    case 18:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.SOLUTION,
      }

    default:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.DEFAULT,
      }
  }
}
